const setBringOffline = async ({
    worldContract,
    smartObjectId
  }: {
    worldContract: any;
    smartObjectId: string;
  }): Promise<string | undefined> => {
    let txHash;
  
    txHash = await worldContract.write.eveworld__bringOffline([smartObjectId]);

    return txHash;
  };
  
  export default setBringOffline;
  